import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
// import Button from "@material-ui/core/Button";
import clsx from "clsx";
import {
  sexCheck,
  smokingCheck,
  dmynCheck,
  pyeCheck,
  tbsickCheck,
} from "../../../utils/cancerCalView";

const useStyles = makeStyles((theme) => ({
  header: {
    marginTop: 80,
    marginBottom: 56,
    [theme.breakpoints.down("sm")]: {
      marginTop: 40,
      marginBottom: 32,
    },
  },
  title: {
    marginBottom: 18,
  },

  regular: {
    fontSize: 22,
    fontWeight: 500,
    [theme.breakpoints.down("md")]: {
      fontSize: 22,
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: 16,
    },
  },
  regular2: {
    fontWeight: 500,
  },
  bold: {
    fontWeight: 600,
  },
  info: {
    display: "flex",
    alignItems: "center",
    margin: "8px 0px",
    color: "#1a2633",
    width: 120,
    [theme.breakpoints.down("md")]: {
      width: 100,
      paddingLeft: 20,
    },
    [theme.breakpoints.down("sm")]: {
      width: 80,
    },
  },
  infoLine: {
    flex: 1,
    background: "#60768e",
    height: 1,
    fontSize: 0,
    lineHeight: 0,
    margin: "0px 16px",
  },
  body: {
    marginTop: 24,
    marginBottom: 117,
    [theme.breakpoints.down("lg")]: {
      marginBottom: 80,
    },
    [theme.breakpoints.down("md")]: {
      paddingLeft: 20,
      paddingRight: 20,
    },
    [theme.breakpoints.down("sm")]: {
      marginBottom: 12,
    },
  },
  bodybol: {
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "flex-start",
    },
    // marginTop: 32,
    // marginBottom: 32,
  },
  inputLine: {
    width: "50%",
    color: "#1a2633",
  },
  buttons: {
    float: "left",
    "& > .on": {
      color: theme.palette.primary.main,
      border: `1px solid ${theme.palette.primary.main}`,
    },
    "& > div": {
      display: "inline-block",
      fontSize: 18,
      width: 80,
      height: 36,
      marginRight: 16,
      cursor: "pointer",
      textAlign: "center",
      lineHeight: 2.1,
      color: "#b1b1b1",
      borderRadius: 3,
      border: "1px solid #b1b1b1",
    },
  },
  icon: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  button: {
    width: 432,
    height: 78,
    fontSize: 20,
    [theme.breakpoints.down("md")]: {
      width: "calc(50% - 20px)",
      height: 58,
      fontSize: 18,
    },
    [theme.breakpoints.down("sm")]: {
      width: "calc(50% - 4px)",
      height: 58,
      fontSize: 18,
    },
  },
  buttonBack: {
    width: 432,
    height: 78,
    fontSize: 20,
    backgroundColor: "#ffffff",
    "&:hover": {
      backgroundColor: "#ffffff",
    },
    [theme.breakpoints.down("md")]: {
      width: "calc(50% - 20px)",
      height: 58,
      fontSize: 18,
    },
    [theme.breakpoints.down("sm")]: {
      width: "48%",
      height: 58,
      fontSize: 18,
    },
  },
  sex: {
    paddingRight: 6,
  },
  viewtitle: {
    color: "#60768e",
    fontSize: 23,
    [theme.breakpoints.down("md")]: {
      fontSize: 23,
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: 17,
    },
  },
  title1: {
    width: 65,
    color: "#60768e",
  },
  title2: {
    width: 220,
    color: "#60768e",
    [theme.breakpoints.down("md")]: {
      width: 220,
    },
    [theme.breakpoints.down("sm")]: {
      width: 164,
    },
  },
  col1: {
    width: "25%",
    alignItems: 'flex-start',
    alignSelf: 'stretch',
    [theme.breakpoints.down("md")]: {
      width: "25%",
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      marginBottom: theme.spacing(3.5),
    },
  },
  col2: {
    width: "35%",
    alignItems: 'flex-start',
    alignSelf: 'stretch',
    [theme.breakpoints.down("md")]: {
      width: "35%",
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      marginBottom: theme.spacing(3.5),
    },
  },
  col3: {
    width: "34%",
    alignItems: 'flex-start',
    alignSelf: 'stretch',
    [theme.breakpoints.down("md")]: {
      width: "34%",
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      marginBottom: theme.spacing(3.5),
    },
  },
  content: {
    marginTop: 32,
    [theme.breakpoints.down("lg")]: {
      marginTop: 20,
    },
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(2),
    },
  },
  additionalText: { 
    fontSize: 20,
    paddingLeft: 100, 
    paddingRight: 100, 
    marginTop: 30,
    alignSelf: 'stretch',
    [theme.breakpoints.down("sm")]: {
      fontSize: 14,
      paddingLeft: 20, 
      paddingRight: 20, 
      },
  },
  footer: {
    marginTop: 12,
    marginBottom: 36,
    [theme.breakpoints.down("md")]: {
      paddingLeft: 20,
      paddingRight: 20,
    },
  },
}));

const FormList = ({ score, data, onChange, onTotal }) => {
  const classes = useStyles();
  return (
    <>
      <Grid container justify="space-between" alignItems="center">
        <Grid className={classes.info}>
          <Typography variant="h3">입력정보</Typography>
        </Grid>
        <Grid className={classes.infoLine}></Grid>
      </Grid>
      <Grid
        container
        className={classes.body}
        justify="space-between"
        alignItems="center"
        direction="column"
      >
        <Grid
          className={classes.bodybol}
          container
          justify="space-between"
          alignItems="center"
        >
          <Grid className={classes.col1}>
            <Grid container>
              <Typography variant="h4">
                <span className={clsx(classes.bold, classes.viewtitle)}>
                  기본정보
                </span>
              </Typography>
              <Grid container className={classes.content}>
                <Grid className={classes.title1}>
                  <Typography variant="h4">
                    <span className={classes.regular}>성별</span>
                  </Typography>
                </Grid>
                <Grid>
                  <Typography variant="h4">
                    <span className={classes.regular}>
                      {sexCheck(data.sex)}
                    </span>
                  </Typography>
                </Grid>
              </Grid>
              <Grid container className={classes.content}>
                <Grid className={classes.title1}>
                  <Typography variant="h4">
                    <span className={classes.regular}>연령</span>
                  </Typography>
                </Grid>
                <Grid>
                  <Typography variant="h4">
                    <span className={classes.regular}>{data.age} 세</span>
                  </Typography>
                </Grid>
              </Grid>
              <Grid container className={classes.content}>
                <Grid className={classes.title1}>
                  <Typography variant="h4">
                    <span className={classes.regular}>신장</span>
                  </Typography>
                </Grid>
                <Grid>
                  <Typography variant="h4">
                    <span className={classes.regular}>{data.cm} cm</span>
                  </Typography>
                </Grid>
              </Grid>
              <Grid container className={classes.content}>
                <Grid className={classes.title1}>
                  <Typography variant="h4">
                    <span className={classes.regular}>체중</span>
                  </Typography>
                </Grid>
                <Grid>
                  <Typography variant="h4">
                    <span className={classes.regular}>{data.kg} kg</span>
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid className={classes.col2}>
            <Grid container>
              <Typography variant="h4">
                <span className={clsx(classes.bold, classes.viewtitle)}>
                  병력 및 생활습관 정보
                </span>
              </Typography>
              <Grid container className={classes.content}>
                <Grid className={classes.title2}>
                  <Typography variant="h4">
                    <span className={classes.regular}>당뇨</span>
                  </Typography>
                </Grid>
                <Grid>
                  <Typography variant="h4">
                    <span className={classes.regular}>
                      {dmynCheck(data.dmyn)}
                    </span>
                  </Typography>
                </Grid>
              </Grid>
              <Grid container className={classes.content}>
                <Grid className={classes.title2}>
                  <Typography variant="h4">
                    <span className={classes.regular}>고혈압 이력</span>
                  </Typography>
                </Grid>
                <Grid>
                  <Typography variant="h4">
                    <span className={classes.regular}>
                      {!data.hbp ? '없음' : '있음'}
                    </span>
                  </Typography>
                </Grid>
              </Grid>
              <Grid container className={classes.content}>
                <Grid className={classes.title2}>
                  <Typography variant="h4">
                    <span className={classes.regular}>이상지질혈증 이력</span>
                  </Typography>
                </Grid>
                <Grid>
                  <Typography variant="h4">
                    <span className={classes.regular}>
                      {!data.dyslip ? '없음' : '있음'}
                    </span>
                  </Typography>
                </Grid>
              </Grid>
              <Grid container className={classes.content}>
                <Grid className={classes.title2}>
                  <Typography variant="h4">
                    <span className={classes.regular}>흡연 이력</span>
                  </Typography>
                </Grid>
                <Grid>
                  <Typography variant="h4">
                    <span className={classes.regular}>
                      {!data.brsmoking ? '없음' : '있음'}
                    </span>
                  </Typography>
                </Grid>
              </Grid>
              <Grid container className={classes.content}>
                <Grid className={classes.title2}>
                  <Typography variant="h4">
                    <span className={classes.regular}>음주 이력</span>
                  </Typography>
                </Grid>
                <Grid>
                  <Typography variant="h4">
                    <span className={classes.regular}>
                      {!data.drinking ? '없음' : '있음'}
                    </span>
                  </Typography>
                </Grid>
              </Grid>
              <Grid container className={classes.content}>
                <Grid className={classes.title2}>
                  <Typography variant="h4">
                    <span className={classes.regular}>규칙적 운동</span>
                  </Typography>
                </Grid>
                <Grid>
                  <Typography variant="h4">
                    <span className={classes.regular}>
                      {!data.exercise ? '없음' : '있음'}
                    </span>
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid className={classes.col3}>
            <Grid container>
              <Typography variant="h4">
                <span className={clsx(classes.bold, classes.viewtitle)}>
                  여성력 정보
                </span>
              </Typography>
              <Grid container className={classes.content}>
                <Grid className={classes.title2}>
                  <Typography variant="h4">
                    <span className={classes.regular}>출산</span>
                  </Typography>
                </Grid>
                <Grid>
                  <Typography variant="h4">
                    <span className={classes.regular}>
                      {data.childbirth == 1 ? '1명' : data.childbirth == 2 ? '2명 이상' : '0명'}
                    </span>
                  </Typography>
                </Grid>
              </Grid>
              <Grid container className={classes.content}>
                <Grid className={classes.title2}>
                  <Typography variant="h4">
                    <span className={classes.regular}>모유수유</span>
                  </Typography>
                </Grid>
                <Grid>
                  <Typography variant="h4">
                    <span className={classes.regular}>
                      {data.breastFeeding == 1 ? '3개월이상' : data.breastFeeding == 2 ? '4개월~1년' : data.breastFeeding == 3 ? '1년이상' : '수유안함'}
                    </span>
                  </Typography>
                </Grid>
              </Grid>
              <Grid container className={classes.content}>
                <Grid className={classes.title2}>
                  <Typography variant="h4">
                    <span className={classes.regular}>월경시작</span>
                  </Typography>
                </Grid>
                <Grid>
                  <Typography variant="h4">
                    <span className={classes.regular}>
                      {data.mensesAge}세
                    </span>
                  </Typography>
                </Grid>
              </Grid>
              <Grid container className={classes.content}>
                <Grid className={classes.title2}>
                  <Typography variant="h4">
                    <span className={classes.regular}>종양 이력</span>
                  </Typography>
                </Grid>
                <Grid>
                  <Typography variant="h4">
                    <span className={classes.regular}>
                      {data.tumor == 1 ? '있음' : data.tumor == 2 ? '모름' : '없음'}
                    </span>
                  </Typography>
                </Grid>
              </Grid>
              <Grid container className={classes.content}>
                <Grid className={classes.title2}>
                  <Typography variant="h4">
                    <span className={classes.regular}>치밀유방</span>
                  </Typography>
                </Grid>
                <Grid>
                  <Typography variant="h4">
                    <span className={classes.regular}>
                      {data.bpd == 1 ? '1단계 지방유방' : data.bpd == 2 ? '2단계 치밀유방 없음' : data.bpd == 3 ? '75%미만' : data.bpd == 4 ? '75%이상' : '모름'}
                    </span>
                  </Typography>
                </Grid>
              </Grid>
              <Grid container className={classes.content}>
                <Grid className={classes.title2}>
                  <Typography variant="h4">
                    <span className={classes.regular}>폐경여부</span>
                  </Typography>
                </Grid>
                <Grid>
                  <Typography variant="h4">
                    <span className={classes.regular}>
                      {data.menopause == 1 ? '월경 있음' : data.menopause == 2 ? '자궁적출술' : data.menopause == 3 ? '폐경' : '모름'}
                    </span>
                  </Typography>
                </Grid>
              </Grid>
              {
                (data.menopause == 3 || ( data.menopause == 2 && data.age >= 50) || ( !data.menopause && data.age >= 50)) && (
                  <Grid container className={classes.content}>
                    <Grid className={classes.title2}>
                      <Typography variant="h4">
                        <span className={classes.regular}>폐경후호르몬제</span>
                      </Typography>
                    </Grid>
                    <Grid>
                      <Typography variant="h4">
                        <span className={classes.regular}>
                        {!data.menopauseHormone ? '복용 안함' : '복용'}
                        </span>
                      </Typography>
                    </Grid>
                  </Grid>  
                )
              }
              <Grid container className={classes.content}>
                <Grid className={classes.title2}>
                  <Typography variant="h4">
                    <span className={classes.regular}>유방암 가족력</span>
                  </Typography>
                </Grid>
                <Grid>
                  <Typography variant="h4">
                    <span className={classes.regular}>
                    {!data.bcfmh ? '없음' : '있음'}
                    </span>
                  </Typography>
                </Grid>
              </Grid>


            </Grid>
          </Grid>
        </Grid>
        {
        !data.bpd && (
          <Grid className={classes.additionalText}>
          치밀 유방에 대한 정보가 없는 경우, 가장 흔한 경우인 3단계로 계산하였습니다. <br/>
          실제 위험도는 귀하의 유방 치밀도에 따라 달라질 수 있습니다    
          </Grid>              
        )
        }
        {
          (!data.menopause || data.menopause == 2) && (
            <Grid className={classes.additionalText}>
            폐경 상태를 잘 모르시는 경우 폐경 여부를 정확히 알수가 없어서,
            50세 미만은 폐경 전으로, 50세 이후는 폐경 후로 가정하여 계산되었습니다. <br/>
            실제 위험도는 귀하의 실제적인 폐경 여부에 따라 달라질 수 있습니다. <br/>
            </Grid>              
          )
        }
      </Grid>
    </>
  );
};

export default FormList;
